import { Component } from '@angular/core';

@Component({
  selector: 'app-pdf-components',
  templateUrl: './pdf-components.component.html',
  styleUrl: './pdf-components.component.scss'
})
export class PdfComponentsComponent {

}
